<template>
  <div class="works">
    <div>
      <h1>Projects I'm really proud of</h1>
      <span class="prepend">./</span>
      <router-link class="works-links" to="/works/dronertc">DroneRTC</router-link>
      <span class="append">&nbsp;&nbsp;&nbsp;[under construction]</span>
      <p>More to come...</p>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.backgroundImg();
  },
  methods: {
    backgroundImg() {
      document.getElementsByTagName('body')[0].style.backgroundImage = 'none';
    }
  }
};
</script>
<style>
.works-links {
  color: #ffeccc;
  font-size: 25px;
  font-style: italic;
}

.prepend {
  color: #ffeccc;
  font-size: 25px;
}
h1 {
  font-family: "Quicksand", sans-serif;
  color: #e49d22;
  font-weight: 100;
  font-style: italic;
}
p {
  font-family: "Quicksand", sans-serif;
  font-weight: 100;
  font-size: 18px;
  grid-column: 3/4;
}
</style>
